module.exports = __webpack_public_path__ + "img/logo_slogan.0b3136e3.svg";